// extracted by mini-css-extract-plugin
module.exports = {"banner":"_93444fe79c--banner--VWzMU"};